var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('slide-bar'),_c('div',{staticClass:"content"},[_c('index-header'),_c('breadcrumb-header'),_c('div',{staticClass:"main scroll"},[_c('keep-alive',{attrs:{"include":_vm.includeList}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }